import { TranslatePipe } from '../../filters/translate.pipe';
import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import Session from '../../utils/session.service';
import RestService from '../../services/core-rest.service';
import AngularHelperService from '../../services/angular-helper.service';
import AngularFilterHelperService from '../../services/angular-filter-helper.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ItemInfoPopoverComponent } from '../item-info-popover/item-info-popover.component';

@Component({
	standalone: true,
	selector: 'modal-employer-reminder-config',
	templateUrl: './modal-employer-reminder-config.component.html',
	imports: [ CommonModule, TranslatePipe, FormsModule, ItemInfoPopoverComponent ]
})
export class ModalEmployerReminderConfigComponent implements OnInit {
	private session: Session = inject(Session);
	private restService: RestService = inject(RestService);
	private angularHelperService: AngularHelperService = inject(AngularHelperService);
	private angularFilterHelperService: AngularFilterHelperService = inject(AngularFilterHelperService);
	private dialogRef = inject(MatDialogRef<ModalEmployerReminderConfigComponent>);
	private data = inject(MAT_DIALOG_DATA);
	
	vm: any = undefined;
	
	constructor() {
		this.vm = this;
	}
	
	ngOnInit() {
		Object.keys(this.data).forEach(key => this.vm[key] = this.data[key]);
		
		this.vm.user = this.session.getSession().user;
		this.vm.isBusinessClient = this.vm.user.businessUserType === 'BUSINESS_CLIENT';
		this.vm.businessServiceSetting = this.angularHelperService.copy(this.vm.businessServiceSetting) || {};
		this.vm.projectName = this.vm.user.origin === 'siffi.com' ? 'Siffi' : 'Minudoc';
		
		this.vm.close = this.close;
		this.vm.sendActivationEmployeeReminder = this.sendActivationEmployeeReminder;
		this.vm.sendSessionLimitReminder = this.sendSessionLimitReminder;
	}
	
	close() {
		this.dialogRef.close();
	}
	
	sendActivationEmployeeReminder() {
		this.restService.saveSendActivationEmployeeReminder(this.vm.businessServiceSetting.user.id)
			.then((data) => {
				this.vm.activationEmailsSent = true;
			})
			.catch((err) => {
				var error: any = err.error.split(" ");
				var errorName: any = error[0];
				var interval: any = error[1];
				this.vm.errorActivationReminderIntervalNotLeftInfo =
					this.angularFilterHelperService.translate('Employees.Error_Activation_Reminder_Interval_Not_Left').replace('%s', interval);
				if (err.status === 400 && errorName === "ACTIVATION_REMINDER_NOT_ENABLED") {
					this.vm.errorActivationReminderNotEnabled = true;
				} else if (err.status === 400 && errorName === "ACTIVATION_REMINDER_INTERVAL_NOT_LEFT") {
					this.vm.errorActivationReminderIntervalNotLeft = true;
				} else if (err.status === 400 && errorName === "ACTIVATION_REMINDER_NOT_ADMIN_OR_HR") {
					this.vm.errorActivationReminderNotAdminOrHr = true;
				} else {
					this.vm.errorSendingEmails = true;
				}
				this.vm.activationEmailsSent = false;
			});
	}
	
	sendSessionLimitReminder() {
		this.restService.saveSendSessionLimitReminder(this.vm.businessServiceSetting.user.id)
			.then((data) => {
				this.vm.sessionLimitEmailsSent = true;
			})
			.catch((err) => {
				var error: any = err.error.split(" ");
				var errorName: any = error[0];
				var interval: any = error[1];
				this.vm.errorSessionLimitReminderIntervalNotLeftInfo =
					this.angularFilterHelperService.translate('Employees.Error_Session_Limit_Reminder_Interval_Not_Left')
						.replace('%s', interval);
				if (err.status === 400 && errorName === "SESSION_LIMIT_REMINDER_NOT_ENABLED") {
					this.vm.errorSessionLimitReminderNotEnabled = true;
				} else if (err.status === 400 && errorName === "SESSION_LIMIT_REMINDER_INTERVAL_NOT_LEFT") {
					this.vm.errorSessionLimitReminderIntervalNotLeft = true;
				} else if (err.status === 400 && errorName === "SESSION_LIMIT_REMINDER_NOT_ADMIN_OR_HR") {
					this.vm.errorSessionLimitReminderNotAdminOrHr = true;
				} else {
					this.vm.errorSendingEmails = true;
				}
				this.vm.sessionLimitEmailsSent = false;
			});
		
	}
	
}